import { Flex, HStack, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { pieChartProps, titleProps } from "../../pie-chart/shared";
import { Cell, Pie, PieChart, Tooltip } from "recharts";
import { PieChartTooltip } from "../../pie-chart/PieChartToolTip";
import { CustomLabel } from "../../pie-chart/CustomLabel";
import { useCraScorePieCharts } from "../../../hooks/useCraScorePieCharts";
import { observer } from "mobx-react-lite";

import { RiskFactor, Score } from "@keita/lanepatrol-sdk";
import {
  tRiskFactor,
  tScoreType,
} from "../../../../../coding/utils/score-utils";
import { useStores } from "../../../../../shared/stores/RootStore";

const PieChartFullScoreBase: React.FC = () => {
  const { filterStore } = useStores();

  const data = useCraScorePieCharts(
    filterStore.filteredCraDistance,
    filterStore.filteredNodes
  );

  return (
    <HStack overflowX="auto" fontSize="sm" gap={0}>
      {data ? (
        Object.entries(data).map(([scoreType, data], i) => {
          const clockwiseData = [...data].reverse();
          return (
            clockwiseData.length > 0 && (
              <Flex key={i} flexDirection="column" alignItems="center">
                <Text {...titleProps}>
                  {tScoreType(scoreType as keyof Score)}
                </Text>
                <PieChart {...pieChartProps}>
                  <Tooltip
                    content={
                      <PieChartTooltip
                        translate={(s) => tRiskFactor(s as RiskFactor)}
                      />
                    }
                  />

                  <Pie
                    nameKey="name"
                    dataKey="value"
                    label={CustomLabel}
                    data={clockwiseData}
                    outerRadius={72}
                  >
                    {clockwiseData.map((entry, i) => (
                      <Cell key={i} fill={entry.color} />
                    ))}
                  </Pie>
                </PieChart>
              </Flex>
            )
          );
        })
      ) : (
        <Text px={4} py={2} fontSize="xs">
          {t(`map:pieChart.noData`)}
        </Text>
      )}
    </HStack>
  );
};

export const PieChartFullScore = observer(PieChartFullScoreBase);
